const geoStandardOptions = Object.freeze({
    enableHighAccuracy: false,
    timeout: 0xFFFFFFFF,
    maximumAge: 0,
});
export default geoStandardOptions;
